export const posts = [
  {
    id: '1',
    title: 'Expert Tree Care Tips for Homeowners in Overland Park',
    metaTitle: 'Top Tree Care Tips for Overland Park Homeowners',
    excerpt: 'Seeking expert advice for maintaining the trees on your property? This article shares top tips for homeowners in Overland Park, KS. Learn how to keep your trees healthy and thriving all year round.',
    slug: 'expert-tree-care-tips-for-homeowners-in-overland-park',
    tags: ['tree care', 'tips', 'Overland Park'],
    metaDescription: 'Discover professional advice for keeping your trees healthy in Overland Park. Contact us for expert tree care solutions in Kansas.',
    lastModified: new Date('2023-12-03').toISOString(),
    createdAt: new Date('2023-12-03').toISOString()
  },
  {
    id: '2',
    title: 'Benefits of Regular Tree Trimming in Overland Park',
    metaTitle: 'Discover the Benefits of Regular Tree Trimming',
    excerpt: 'Regular tree trimming offers multiple benefits for both your trees and property. Discover the advantages and why it\'s essential to hire professionals for the job.',
    slug: 'benefits-of-regular-tree-trimming-in-overland-park',
    tags: ['tree trimming', 'benefits', 'Overland Park'],
    metaDescription: 'Discover the benefits of regular tree trimming for your property in Overland Park. Learn why professional service is crucial for optimal results.',
    lastModified: new Date('2023-12-15').toISOString(),
    createdAt: new Date('2023-12-15').toISOString()
  },
  {
    id: '3',
    title: 'The Importance of Tree Removal for Overland Park Homeowners',
    metaTitle: 'Tree Removal for Home Safety - Overland Park Tree Care',
    excerpt: 'Tree removal can be a necessary, yet challenging task for homeowners. Learn why it’s crucial for safety and when it’s time to call professionals.',
    slug: 'importance-of-tree-removal-for-overland-park-homeowners',
    tags: ['tree removal', 'safety', 'Overland Park'],
    metaDescription: 'Discover why tree removal is a critical aspect of home safety and learn the signs that indicate it’s time for a tree to be removed.',
    lastModified: new Date('2023-12-20').toISOString(),
    createdAt: new Date('2023-12-20').toISOString()
  },
  {
    id: '4',
    title: 'Understanding the Value of Professional Arborist Services in Overland Park',
    metaTitle: 'Why Hire Professional Arborists in Overland Park',
    excerpt: 'Professional arborist services provide critical benefits for the health and beauty of your trees. Learn why hiring an arborist is a worthwhile investment.',
    slug: 'value-of-professional-arborist-services-in-overland-park',
    tags: ['arborist services', 'value', 'Overland Park'],
    metaDescription: 'Explore the numerous benefits of hiring professional arborist services in Overland Park and why it\'s a worthy investment for any homeowner.',
    lastModified: new Date('2024-1-04').toISOString(),
    createdAt: new Date('2024-1-04').toISOString()
  },
]